import React from 'react';

/**
 * Table footer component showing results count and last updated time
 */
const TableFooter = ({ filteredCount, totalCount }) => {
  if (filteredCount === 0) return null;

  return (
    <div className="flex items-center justify-between text-sm text-text-secondary mt-4">
      <span>Showing {filteredCount} of {totalCount} companies</span>
      <span>
        Last updated: {new Date()?.toLocaleString('en-US', { 
          month: 'short', 
          day: 'numeric', 
          year: 'numeric', 
          hour: '2-digit', 
          minute: '2-digit' 
        })}
      </span>
    </div>
  );
};

export default TableFooter;